let _ = t => t,
  _t;
/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
import Screens from '../../constants/routing/Screens';
import { CREATE_A_BUNDLE, SCREENS } from '../../constants/tracking/Locations';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { useAppSelector } from '../../reducers';
import { countrySelector } from '../../selectors/CountrySelectors';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { hasOnlyOwnershipCheckFailedSelector, hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasPaidHubInProductInventorySelector, hasProductVersionInProductInventorySelector, productVersionsFromProductInventorySelector, productsFromProductInventoryQuantitySelector } from '../../selectors/ProductInventorySelectors';
import PhoneSupport from '../common/PhoneSupport';
import CompareStatusFooter from '../compare/CompareStatusFooter';
// import StyledBlob from '../common/StyledBlob';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getRootUrl } from 'pricing-pages-lib/utils/urls';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { Redirect } from 'react-router-dom';
import { OWNERSHIP_CHECK_FAILED } from '../../constants/ErrorCauses';
import { useAddOnsPage } from '../../hooks/useAddOnPage';
import useIsEligibleForHsfxDiscount from '../../hooks/useIsEligibleForHsfxDiscount';
import { isQuantifiableHubSelector, skuIdHasBundledProductsSelector } from '../../selectors/ProductsSelectors';
import { useSSM0002Experiment } from '../../utils/experiments/ssm0002';
import { useQueryParamTerm, useQueryParamsEffect } from '../../utils/urls/appQueryParamUtils';
import BannerSection from '../banners/BannerSection';
import FailedLoadBanner from '../common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../common/loading/FallbackErrorBanner';
import ErrorPage from '../error-page/ErrorPage';
import HeaderLayout from '../layout/HeaderLayout';
import AddonsPickerList from '../plan-builder/AddonsPickerList';
import HubPlanPickerListContainerAll from '../plan-builder/HubPlanPickerList/HubPlanPickerListContainerAll';
import PlanBuilder from '../plan-builder/PlanBuilder';
import SummaryColumn from '../plan-builder/SummaryColumn';
import ProductPageSubtitle from '../product-pages/ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from '../product-pages/ProductPageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContentContainer = styled.main.attrs({
  role: 'main'
}).withConfig({
  displayName: "BundlePage__ContentContainer",
  componentId: "pgkx9w-0"
})(["max-width:1150px;width:inherit;"]);
const RightColumnWrapper = styled.div.withConfig({
  displayName: "BundlePage__RightColumnWrapper",
  componentId: "pgkx9w-1"
})(["width:400px;margin-top:34px;margin-left:10px;", ";"], breakpoint.cs(_t || (_t = _`
    margin: 0 auto;
  `)));
const BundlePage = () => {
  useTrackRetail();
  useDocumentTitle('bundle');
  const country = useSelector(countrySelector);
  const activeCurrencyCode = useSelector(activeCurrencySelector);
  const eligibleForHsfxDiscount = useIsEligibleForHsfxDiscount();
  const {
    isSSM0002Loading,
    isSSM0002Variant
  } = useSSM0002Experiment();
  useEffect(() => {
    getUsageTracker().setProperties({
      activeCurrencyCode,
      countryTerritory: country,
      defaultedTab: '',
      tab: ''
    });
    getUsageTracker().track('pageView', {
      screen: SCREENS.CREATE_BUNDLE
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const hasOnlyOwnershipCheckFailed = useSelector(hasOnlyOwnershipCheckFailedSelector);
  const {
    showAddonsPage
  } = useAddOnsPage();
  const initialProductConfigurations = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) {
      return [];
    }
    if (hasPaidHubInProductInventorySelector(state, {
      productLevels: [PROFESSIONAL, ENTERPRISE]
    })) {
      const ownedProductVersions = productVersionsFromProductInventorySelector(state);
      return ownedProductVersions.filter(productVersion => {
        return isQuantifiableHubSelector(state, {
          skuId: productVersion.skuId
        }) || skuIdHasBundledProductsSelector(state, {
          skuId: productVersion.skuId
        });
      }).map(productVersion => createProductConfig({
        skuId: productVersion.skuId,
        quantity: productsFromProductInventoryQuantitySelector(state, {
          skuId: productVersion.skuId
        })
      }));
    }
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    }).filter(({
      skuId
    }) => !hasProductVersionInProductInventorySelector(state, {
      skuId
    }) || skuIdHasBundledProductsSelector(state, {
      skuId
    }));
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  if (hasPricingAndPurchasingFailed) {
    if (hasOnlyOwnershipCheckFailed) {
      return /*#__PURE__*/_jsx(ErrorPage, {
        errorCause: OWNERSHIP_CHECK_FAILED
      });
    }
  }

  // Redirect to root pricing page for SSM0002 variant - Hide CaB page for In-App portals
  // (Redirecting to root so recommendation engine can take over)
  if (!isSSM0002Loading && isSSM0002Variant) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: getRootUrl()
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: "BUNDLE_PAGE"
    }), /*#__PURE__*/_jsx(HeaderLayout, {
      selectedNavItem: 'bundle',
      children: /*#__PURE__*/_jsxs(ContentContainer, {
        children: [eligibleForHsfxDiscount && /*#__PURE__*/_jsx(BannerSection, {
          screen: NavItemEnum.BUNDLE
        }), /*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(ProductPageHeader, {
          children: [/*#__PURE__*/_jsx(ProductPageTitle, {
            nonProductIdentifier: NavItemEnum.BUNDLE
          }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
            nonProductIdentifier: NavItemEnum.BUNDLE
          })]
        }), /*#__PURE__*/_jsx(PlanBuilder, {
          initialProductConfigurations: initialProductConfigurations,
          allowUpgradesToCrmSuite: true,
          trackingSource: CREATE_A_BUNDLE,
          screen: Screens.BUNDLE,
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex-column",
              style: {
                flex: 1
              },
              children: [/*#__PURE__*/_jsx(HubPlanPickerListContainerAll, {
                productLines: AllProductLines,
                compact: false
              }), !showAddonsPage && /*#__PURE__*/_jsx(AddonsPickerList, {
                defaultOpen: true,
                screen: Screens.BUNDLE
              })]
            }), /*#__PURE__*/_jsxs(RightColumnWrapper, {
              children: [/*#__PURE__*/_jsx(SummaryColumn, {
                shareLinkAnchor: "",
                hubsSignupProductOverride: "bundle"
              }), /*#__PURE__*/_jsx(PhoneSupport, {
                className: "m-top-5",
                phoneSourceId: "bundle",
                border: false,
                screen: Screens.BUNDLE
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
  });
};
export default BundlePage;